<template>
    <v-dialog
            v-model="dialog"
            max-width="330"

    >

        <v-card >
            <v-card-title class="headline-2"><v-spacer></v-spacer><span>Öppna Hihat i Webbläsare</span><v-spacer></v-spacer></v-card-title>

            <v-card-text>

                <ol style="margin-top:10px;padding-bottom:10px;">
                    <li>Tryck <v-icon>mdi-dots-vertical</v-icon> högst upp till höger</li>
                    <li>Tryck <i>Öppna i Webbläsaren</i> </li>
                </ol>


            </v-card-text>


        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "WebViewHandler",
        data:function() {
            return {
                dialog:false
            }
        },
        mounted:function(){
            let isWV=navigator.userAgent.includes ('wv');
            this.dialog=isWV;
        }
    }
</script>

<style scoped>

</style>
